import * as React from 'react';
import * as classNames from 'classnames';
import { Link } from 'react-router-dom';
import { NavigationRoot, NavigationItem } from '../../../../../../models';
import './style.css';

export interface DesktopNavigationSubmenuProps {
  item: NavigationRoot;
}

export interface DesktopNavigationSubmenuState {
  /* empty */
}

export class DesktopNavigationSubmenu extends React.Component<
  DesktopNavigationSubmenuProps,
  DesktopNavigationSubmenuState
> {
  render() {
    const { item } = this.props;

    return (
      <div className="desktop-navigation-submenu-wrapper">
        <ul className="desktop-navigation-submenu">
          {item.children.map(this.getSubMenuItem)}
        </ul>
      </div>
    );
  }

  private getSubMenuItem = (item: NavigationItem): JSX.Element => {
    const classes = classNames({
      'desktop-navigation-submenu-item': true
    });

    const title = item.name;

    return (
      <li className={classes} key={title}>
        <Link
          className="edge-of-play-link desktop-navigation-link"
          to={item.url || `#`}
          onClick={item.onClick}
        >
          {title}
        </Link>
      </li>
    );
  };
}

export default DesktopNavigationSubmenu;



// WEBPACK FOOTER //
// ./src/app/components/App/Navigation/DesktopNavigation/DesktopNavigationItem/DesktopNavigationSubmenu/index.tsx